const getCheckedItems = (checkedState: {[key: string]: boolean}) => (
  Object.keys(checkedState).filter((key) => +checkedState[key] || checkedState[key])
);

export default getCheckedItems;
